export default {
	props:{
		thumbs: {type: Boolean, default:true},
		images: Array
	},
	data(){
		return {
			swiperGallery: null,
			swiperThumbs: null,
		}
	},
	computed:{
		cp_numImages(){
			return this.images.length;
		}
	},
	methods: {
		init(){
			let self = this;
			ITTI.defer(function (){
				if(self.thumbs){
					self.swiperThumbs = new Swiper(self.$refs.swiperThumbs, {
						loop: true,
						spaceBetween:5,
						slidesPerView: 'auto',
						loopedSlides:2,
						freeMode: true,
						freeModeSticky: true,
						watchSlidesVisibility: true,
						watchSlidesProgress: true,
						preloadImages: false, //Disable preloading of all images
						lazy: { loadPrevNext: true, },
						on: {
							init: function () {
								let sw = this;
								setTimeout(()=>{ sw.lazy.load(); }, 100);
							},
						},
					});
				}
				self.swiperGallery = new Swiper (self.$refs.swiperGallery, {
					loop:true,
					spaceBetween: 0,
					initialSlide: 0,
					keyboard:true,
					grabCursor:true,
					observer:true,
					observeParents:true,
					observeSlideChildren:true,
					preloadImages: false, //Disable preloading of all images
					pagination: {el:'.swiper-pagination', type: 'fraction'},
					navigation: {nextEl: '.swiper-button-next',prevEl: '.swiper-button-prev'},
					lazy: {loadPrevNext: true,},
					thumbs: {swiper: self.swiperThumbs,},
				});
			}, ['swiperJS']);
		},
		show(){
			this.$refs.modalDialog.show();
			this.$nextTick(()=>{ this.init(); });
		},
		hide(){
			this.$refs.modalDialog.hide();
		},
		onModalDialogHidden(){
			if(this.swiperThumbs) {
				this.swiperThumbs.destroy();
				this.swiperThumbs = null;
			}
			if(this.swiperGallery) {
				this.swiperGallery.destroy();
				this.swiperGallery = null;
			}
		},
	},
	mounted(){
		//this.init();
	},
	template: `
<qit-modal-dialog class="size-fs gallery-swiper-lightbox" ref="modalDialog" @hide="onModalDialogHidden">
	<div class="swiper-container swiper-container-gallery image__holder" ref="swiperGallery">
		<div class="swiper-wrapper">
			<div class="swiper-slide" v-for="(src,i) in images" :key="i">
				<img :data-src="src" class="swiper-lazy">
			</div>
		</div>
		<div class="swiper-button-next swiper-button-white"></div>
		<div class="swiper-pagination swiper-pagination-white"></div>
		<div class="swiper-button-prev swiper-button-white"></div>
	</div>
	<div v-if="thumbs" class="thumbs-wrap">
		<div class="swiper-container swiper-container-thumbs" ref="swiperThumbs">
			<div class="swiper-wrapper">
				<div class="swiper-slide img16x9 image__holder" v-for="(src,i) in images" :key="i">
					<img :data-src="src" class="swiper-lazy">
				</div>
			</div>
		</div>
	</div>
</qit-modal-dialog>
`,
}
